<template>
  <div>
    <div v-if="profile === false">
      <div v-if="dispatcherLocationFlow === false || salesman_location_required == 1" class="w3-center">
        <br>
        <div id="floating-panel" @click="onClickCurrentLocationButtion();">
          <img src="../../../../static/img/currentlocation.png" style="width:17%;">
        </div>
        <gmap-map v-bind:center='center' v-bind:zoom='14' style='height: 250px'>
          <gmap-marker v-bind:key='index' v-for='(m, index) in markers' v-bind:position='m.position' v-bind:clickable='true' v-bind:draggable="true" @drag="updateCoordinates"></gmap-marker>
        </gmap-map><br>
        <b>Set Delivery Location on map and write complete address below</b>
      </div>
      <div>
        <form>
          <div style="margin-left: 5%; margin-top: 5%; width: 90%;">
            <div v-if="dispatcherLocationFlow === false || salesman_location_required == 1">
              <!-- <input style="margin-bottom: 5%; color: gray; font-style: italic;" class="location_edit" id="del_loc" placeholder="" readonly="true"> --><!-- <br><hr style="display: block; height: 1px; border: 0; border-top: 1px solid gray; margin: 0em 0%;padding: 0; margin-bottom: 5%;"> -->
              <textarea style="color: gray; font-style: italic;" class="location_edit" id="del_loc" placeholder="" readonly="true"></textarea>
            </div>
            <div v-else style="text-align: center; font-size: 18px; margin-bottom: 1rem;">
              Fill Delivery Address
            </div>
            <input class="location_edit" id="address1" v-model="address1" placeholder="* H. NO | FLOOR | LOCALITY | AREA"><br><hr style="display: block; height: 1px; border: 0; border-top: 1px solid gray; margin: 0em 0%;padding: 0; margin-bottom: 5%;">
            <div  v-if="dispatcherLocationFlow === true">
              <!-- <input class="location_edit" v-model="city" placeholder="* CITY"><br><hr style="display: block; height: 1px; border: 0; border-top: 1px solid gray; margin: 0em 0%;padding: 0; margin-bottom: 5%;"> -->
              <span style="margin-bottom: 1rem;">City : 
                <b-select
                  v-model="city"
                  placeholder="Select City"
                  >
                  <option
                    v-for="location in cityList"
                    :value="location.city_name"
                    :key="location.city_name">
                    {{ location.city_name }}
                  </option>
                </b-select>
              </span>
              <input style="margin-top: 1rem;" class="location_edit" v-model="pincode" maxlength="6" placeholder="* PINCODE"><br><hr style="display: block; height: 1px; border: 0; border-top: 1px solid gray; margin: 0em 0%;padding: 0; margin-bottom: 5%;">
            </div>
            <input class="location_edit" id="address2" v-model="address2" placeholder="LANDMARK[OPTIONAL]"><br><hr style="display: block; height: 1px; border: 0; border-top: 1px solid gray; margin: 0em 0%;padding: 0; margin-bottom: 5%;">
          </div>
          <input class="subprofile" value="NEXT" type="button" v-on:click="onSubmit();">
        </form>
      </div>
    </div>
    <div v-if="profile">
      <div class="w3-center">
        <br>
        <img src="../../../../static/img/boy.png" style="width:35%;"><br><br>
        <input type="radio" id="male" value="M" v-model="gender">
        <label for="male">Male</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <input type="radio" id="female" value="F" v-model="gender">
        <label for="female">Female</label>
      </div>
      <div>
        <form>
          <div style="margin-left: 5%; margin-top: 5%; width: 90%;">
            <input class="profile_edit" id="profile_name" placeholder="* NAME"><br><hr style="display: block; height: 1px; border: 0; border-top: 1px solid gray; margin: 0em 0%;padding: 0; margin-bottom: 5%;">
            <input class="profile_edit" id="profile_email" placeholder="* EMAIL"><br><hr style="display: block; height: 1px; border: 0; border-top: 1px solid gray; margin: 0em 0%;padding: 0; margin-bottom: 5%;">
            <input v-if="salesman_flow == 0" class="profile_edit" id="profile_referral" placeholder="REFERRAL CODE[OPTIONAL]"><br><hr v-if="salesman_flow == 0" style="display: block; height: 1px; border: 0; border-top: 1px solid gray; margin: 0em 0%;padding: 0; margin-bottom: 5%;">
            <br><br>
          </div>
          <input class="subprofile" value="SUBMIT" type="button" v-on:click="profileSetApi();">
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  export default {
    data () {
      return {
        dispatcherLocationFlow: false,
        salesman_flow: 0,
        salesman_location_required: 0,
        pincode: '000000',
        city: 'North Delhi',
        country: '',
        state: '',
        locality: '',
        formattedAddress: '',
        profileSet: [],
        userDetails: [],
        cityList: [],
        gender: 'M',
        profile: false,
        address1: '',
        address2: '',
        center: { lat: 0, lng: 0 },
        markers: [
          {
            position: { lat: 0, lng: 0 }
          }
        ]
      }
    },
    created () {
      if (sessionStorage.getItem('salesman_flow') !== null) {
        this.salesman_flow = sessionStorage.getItem('salesman_flow')
      }
      if (sessionStorage.getItem('dispatcherId') !== null) {
        this.dispatcherLocationFlow = true
        this.pincode = ''
        // call api to get cities
        this.getCities()
      }
      if (sessionStorage.getItem('salesman_location_required') !== null) {
        this.salesman_location_required = sessionStorage.getItem('salesman_location_required')
      }
      if (sessionStorage.getItem('actionName') === 'subscription' && sessionStorage.getItem('locationAction') === 'getOldLocation') {
        const params = new URLSearchParams()
        var userId = sessionStorage.getItem('userId')
        params.append('user_id', userId)
        axios({
          url: process.env.BASE_API + '/users/user-info',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          // console.log(response)
          this.address1 = response.data.user_record.address.address1
          this.address2 = response.data.user_record.address.address2
          sessionStorage.setItem('custAddress1', this.address1)
          sessionStorage.setItem('custAddress2', this.address2)
          this.markers[0].position.lat = parseFloat(response.data.user_record.address.latitude)
          this.markers[0].position.lng = parseFloat(response.data.user_record.address.longitude)
          this.center.lat = parseFloat(response.data.user_record.address.latitude)
          this.center.lng = parseFloat(response.data.user_record.address.longitude)
          this.address(this.markers[0].position.lat, this.markers[0].position.lng)
        })
        .catch(e => {
          alert('not ok')
        })
      }
      if (sessionStorage.getItem('custAddress1') !== null) {
        this.address1 = sessionStorage.getItem('custAddress1')
      }
      if (sessionStorage.getItem('custAddress2') !== null) {
        this.address2 = sessionStorage.getItem('custAddress2')
      }
      // alert(sessionStorage.getItem("userId"))
      // alert(sessionStorage.getItem('isProfile'))
      if (sessionStorage.getItem('userId') === null) {
        this.$router.push('/a/reg')
      } else if (sessionStorage.getItem('isProfile') === '0' || sessionStorage.getItem('isProfile') === 0) {
        this.userInfo()
      } else {
        this.fetchCurrentLocation()
      }
    },
    methods: {
      fetchCurrentLocation () {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            let pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
            this.center.lat = pos.lat
            this.center.lng = pos.lng
            this.markers[0].position.lat = pos.lat
            this.markers[0].position.lng = pos.lng
            this.address(this.markers[0].position.lat, this.markers[0].position.lng)
          }.bind(this))
        }
      },
      onClickCurrentLocationButtion () {
        sessionStorage.setItem('locationAction', 'currentLocation')
        window.location.reload()
      },
      updateCoordinates (location) {
        this.markers[0].position.lat = location.latLng.lat()
        this.markers[0].position.lng = location.latLng.lng()
        this.address(this.markers[0].position.lat, this.markers[0].position.lng)
      },
      onSubmit () {
        if (document.getElementById('address1').value !== '') {
          this.address1 = document.getElementById('address1').value
          this.address2 = document.getElementById('address2').value
          if (sessionStorage.getItem('actionName') === 'subscription') {
            const params = new URLSearchParams()
            var userId = sessionStorage.getItem('userId')
            params.append('user_id', userId)
            axios({
              url: process.env.BASE_API + '/users/user-info',
              method: 'post',
              data: params,
              withCredentials: false,
              headers: {
              }
            })
            .then(response => {
              // console.log(response)
              const params = new URLSearchParams()
              params.append('user_id', userId)
              params.append('first_name', response.data.user_record.user_details.first_name)
              params.append('pincode', this.pincode)
              params.append('deviceId', response.data.user_record.user.mobile)
              params.append('address1', this.address1)
              params.append('address2', this.address2)
              params.append('state', this.state)
              params.append('gps_address', this.formattedAddress)
              if (this.dispatcherLocationFlow === false || this.salesman_location_required === '1') {
                params.append('latitude', this.markers[0].position.lat)
                params.append('longitude', this.markers[0].position.lng)
              } else {
                params.append('latitude', 0.0)
                params.append('longitude', 0.0)
              }
              params.append('locality', this.locality)
              params.append('region_code', this.pincode)
              params.append('gender', response.data.user_record.user_details.gender)
              params.append('phone', response.data.user_record.user.mobile)
              params.append('email', response.data.user_record.user_details.email)
              params.append('zombie', 0)
              params.append('country_id', 1)
              axios({
                url: process.env.BASE_API + '/users/profile',
                method: 'post',
                data: params,
                withCredentials: false,
                headers: {
                }
              })
              .then(response => {
                // console.log(response)
                if (response.data.status === '000000') {
                  window.location.href = sessionStorage.getItem('callbackUrlForSubscription')
                } else {
                  alert(response.data.msg)
                }
              })
              .catch(e => {
                alert('not ok')
              })
            })
            .catch(e => {
              alert('not ok')
            })
          } else {
            if (sessionStorage.getItem('dispatcherId') !== null) {
              if (isNaN(this.pincode) || this.pincode.length !== 6 || this.pincode === '') {
                this.$swal.fire({text: 'Please enter valid pincode!'})
              } else {
                this.profile = true
              }
            } else {
              this.profile = true
            }
            // this.profile = true
          }
        } else {
          // alert('Please fill address')
          this.$swal.fire({text: 'Please fill address!'})
        }
      },
      address (lats, lngs) {
        let latlng = {lat: lats, lng: lngs}
        const google = window.google
        // alert(google)
        if (google !== undefined) {
          var geocoder = new google.maps.Geocoder()
          var myScope = this
          geocoder.geocode({'location': latlng}, function (results, status) {
            if (status === 'OK') {
              if (results[0]) {
                if (document.getElementById('del_loc')) {
                  document.getElementById('del_loc').value = results[0].formatted_address
                }
                let length = results[0].address_components.length
                length = length - 1
                myScope.pincode = results[0].address_components[length].long_name
                if (sessionStorage.getItem('dispatcherId') !== null) {
                  myScope.pincode = ''
                }
                length = length - 1
                myScope.country = results[0].address_components[length].long_name
                length = length - 1
                myScope.state = results[0].address_components[length].long_name
                length = length - 1
                myScope.locality = results[0].address_components[length].long_name
                length = length - 1
                myScope.formattedAddress = results[0].formatted_address
              } else {
                window.alert('No results found')
              }
            } else {
              // window.alert('Geocoder failed due to: ' + status);
            }
          })
        } else {
          window.location.reload()
        }
      },
      profileSetApi () {
        let firstName = document.getElementById('profile_name').value
        let email = document.getElementById('profile_email').value
        let userid = sessionStorage.getItem('userId')
        if (this.validateEmail(email) && firstName !== '') {
          /* alert('user_id' + userid)
          alert('first_name' + firstName)
          alert('pincode' + this.pincode)
          if (document.getElementById('profile_referral').value !== '') {
            alert('referral_code' + document.getElementById('profile_referral').value)
          }
          alert('deviceId' + sessionStorage.getItem('userMobile'))
          alert('address1' + this.address1)
          alert('address2' + this.address2)
          alert('state' + this.state)
          alert('gps_address' + this.formattedAddress)
          alert('latitude' + this.markers[0].position.lat)
          alert('longitude' + this.markers[0].position.lng)
          alert('locality' + this.locality)
          alert('region_code' + this.pincode)
          alert('gender' + this.gender)
          alert('phone' + sessionStorage.getItem('userMobile'))
          alert('email' + email)
          alert('country_id' + 1) */
          const params = new URLSearchParams()
          params.append('user_id', userid)
          params.append('first_name', firstName)
          params.append('pincode', this.pincode)
          if (sessionStorage.getItem('dispatcherId') !== null) {
            params.append('city', this.city)
          }
          if (this.salesman_flow === 0) {
            params.append('referral_code', document.getElementById('profile_referral').value)
          }
          params.append('deviceId', sessionStorage.getItem('userMobile'))
          params.append('address1', this.address1)
          params.append('address2', this.address2)
          params.append('state', this.state)
          params.append('gps_address', this.formattedAddress)
          // params.append('latitude', this.markers[0].position.lat)
          // params.append('longitude', this.markers[0].position.lng)
          if (this.salesman_location_required === '1') {
            params.append('latitude', this.markers[0].position.lat)
            params.append('longitude', this.markers[0].position.lng)
          } else {
            params.append('latitude', 0.0)
            params.append('longitude', 0.0)
          }
          params.append('locality', this.locality)
          params.append('region_code', this.pincode)
          params.append('gender', this.gender)
          params.append('phone', sessionStorage.getItem('userMobile'))
          params.append('email', email)
          params.append('zombie', 0)
          params.append('country_id', 1)
          if (sessionStorage.getItem('dispatcherId') !== null) {
            params.append('dispatcher_id', sessionStorage.getItem('dispatcherId'))
          }
          axios({
            url: process.env.BASE_API + '/users/profile',
            method: 'post',
            data: params,
            withCredentials: false,
            headers: {
            }
          })
          .then(response => {
            this.profileSet = {}
            if (response.data.status === '000000') {
              // this.$router.push('/a/subscription')
              sessionStorage.setItem('isProfile', 0)
              if (sessionStorage.getItem('urlstr') === 'undefined' || sessionStorage.getItem('urlstr') === null) {
                // this.$router.push('/a/subscription')
                sessionStorage.setItem('productListUrl', response.data.product_list_url)
                window.location.href = response.data.product_list_url
                // window.location.href = 'http://localhost:4000/#/a/productList?4t43'
              } else {
                this.$router.push('/a/s?' + sessionStorage.getItem('urlstr'))
              }
            } else {
              alert(response.data.msg)
            }
            // console.log(response)
            if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
              this.list = response.data.user_record
              alert(this.list)
            }
          })
          .catch(e => {
            alert('not ok')
          })
        } else {
          alert('please fill name and email correctly')
        }
      },
      validateEmail (email) {
        if (this.dispatcherLocationFlow === false) {
          let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return re.test(email)
        } else {
          return true
        }
      },
      userInfo () {
        const params = new URLSearchParams()
        var userId = sessionStorage.getItem('userId')
        params.append('user_id', userId)
        axios({
          url: process.env.BASE_API + '/users/user-info',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.userDetails = {}
          this.userDetails.lat = response.data.user_record.address.latitude
          this.userDetails.lng = response.data.user_record.address.longitude
          if (this.userDetails.lat === 'null' || this.userDetails.lat === '0' || this.userDetails.lat === '0.0' || this.userDetails.lat === null || this.userDetails.lng === 'null' || this.userDetails.lng === '0' || this.userDetails.lng === '0.0' || this.userDetails.lng === null) {
            this.fetchCurrentLocation()
          } else {
            if (sessionStorage.getItem('urlstr') === 'undefined' || sessionStorage.getItem('urlstr') === null) {
              // this.$router.push('/a/subscription')
              if (sessionStorage.getItem('productListUrl') !== null) {
                window.location.href = sessionStorage.getItem('productListUrl')
              } else {
                // this.$router.push('/a/subscription')
              }
            } else {
              this.$router.push('/a/s?' + sessionStorage.getItem('urlstr'))
            }
          }
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },
      getCities () {
        const params = new URLSearchParams()
        axios({
          url: process.env.BASE_API + '/users/cities',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.cityList = response.data.city_list
          console.log(this.cityList)
        })
        .catch(e => {
          alert('not ok')
        })
      }
    }
  }
</script>
<style>
.location_edit {background-color: transparent; border: 0px solid; padding-bottom: 1%; width: 100%;}
.subprofile {background-color: #3CB6C3;width: 100%; padding: 3% 3% 3% 0%;}
.icon {font-size: xx-large; width: 25px;}
/* hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid gray;
    margin: 0em 0%;
    padding: 0; 
    margin-bottom: 5%;
} */
#floating-panel {
  position: absolute;
  z-index: 5;
  margin: 4% 0% 5% 60%;
}
.profile_edit {background-color: transparent; border: 0px solid; padding-bottom: 1%; width: 100%;}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Location.vue